export const TIPOS_TOKEN = {
  OPERADOR: 'operador',
  VARIABLE: 'variable',
  NUMERO: 'numero',
};

// El editor de fórmula simple con botonera gestiona la fórmula llevando
// el control de cada token. Cada token sería un +, un -, un 4,5,
// un competencia_123 etc
export default class Token {
  constructor(tipo, valor, label = null) {
    this.tipo = tipo;
    this.valor = valor;
    this.label = label || valor;
  }

  // Por defecto no dejamos dos tokens del mismo tipo juntos
  siguienteValido(token) {
    return token.tipo !== this.tipo;
  }
}
